import React from 'react';
import { Button, HStack } from 'native-base';
import Modal from './Modal';
import LoadingSpinner from './LoadingSpinner';
import Text from './Text';
import Input from './Input';

interface I_ConfirmationDialog_Props {
  isOpen: boolean;
  onClose: () => void;
  onYesPressed: () => void;
  onNoPressed: () => void;
  description: string;
  title?: string;
  loading?: boolean;
  negativeLabel?: string;
  positiveLabel?: string;
  centerButton?: boolean;
  centerButtonLabel?: string;
  onCenterButtonPressed?: () => void;
  showNotesInput?: boolean;
  notesValue?: string;
  onNotesChange?: (text: string) => void;
  notesPlaceholder?: string;
  notesRequired?: boolean;
}

const ConfirmationDialog = ({
  isOpen,
  onClose,
  onYesPressed,
  onNoPressed,
  description,
  title,
  loading,
  negativeLabel = `NO `,
  positiveLabel = 'YES',
  centerButton,
  centerButtonLabel,
  onCenterButtonPressed,
  showNotesInput = false,
  notesValue = '',
  onNotesChange,
  notesPlaceholder = 'Enter additional comments',
  notesRequired = false,
}: I_ConfirmationDialog_Props) => {
  const isConfirmDisabled = notesRequired && !notesValue.trim();
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Modal.Content>
        <Modal.Header>{!!title ? title : 'Confirm'}</Modal.Header>
        <Modal.Body
          _scrollview={{
            keyboardShouldPersistTaps: 'handled',
          }}>
            {description}
          {showNotesInput && (
            <Input
              mt={4}
              mb={4}
              placeholder={notesPlaceholder}
              value={notesValue}
              onChangeText={onNotesChange}
              isDisabled={loading}
            />
          )}
          <HStack space={2} mt={6}>
            <Button
              flex={1}
              variant="ghost"
              onPress={() => {
                onClose();
                onNoPressed();
              }}
              isDisabled={!!loading}>
              {negativeLabel}
            </Button>
            {centerButton && (
              <Button
                flex={1}
                variant="ghost"
                onPress={() => {
                  onClose();
                  !!onCenterButtonPressed && onCenterButtonPressed();
                }}>
                {centerButtonLabel}
              </Button>
            )}
            {!!loading ? (
              <LoadingSpinner size="small" />
            ) : (
              <Button
                flex={1}
                colorScheme="red"
                isDisabled={isConfirmDisabled}
                onPress={() => {
                  onClose();
                  onYesPressed();
                }}>
                {positiveLabel}
              </Button>
            )}
          </HStack>
        </Modal.Body>
      </Modal.Content>
    </Modal>
  );
};

export default ConfirmationDialog;
